// @ts-nocheck
// EditToolActionButtons: 비디오 편집 도구 상단 액션 버튼 컴포넌트
import React, { use, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';

const EditToolActionButtons = ({
    activeEditTool,
    isEditing,
    setEditTool,
    resetEditList,
    handleSave,
    uuid,
    t
}) => {
    const navigate = useNavigate();
    const organizationData = useSelector((state: any) => state.organization.organizationData);
    const userToken = useSelector((state: any) => state.organization.userToken);
    const isUpdatePendingRedux = useSelector((state: any) => state.editor.isUpdatePending);

    return (
        <Box className="wrapper-edit-tools-btns">
            {!activeEditTool && (
                <Button
                    startIcon={<ArrowBackIosIcon />}
                    size="medium"
                    className="edit-tool-action-buttons__back-button"
                    onClick={() => navigate(`/vod/${uuid}/editor`)}
                >
                    {t('vod.manage.editor_tab.project_list')}
                </Button>
            )}
            {activeEditTool && (
                <div className="edit-tool-action-buttons__action-container">
                    {isEditing ? (
                        <>
                            <Button
                                variant="contained"
                                className="edit-tool-action-buttons__discard-button"
                                onClick={resetEditList}
                            >
                                {t('vod.manage.editor_tab.discard_changes')}
                            </Button>
                            <Button
                                variant="contained"
                                className="edit-tool-action-buttons__save-button"
                                onClick={handleSave}
                            >
                                {t('vod.manage.editor_tab.save')}
                            </Button>
                        </>
                    ) : (
                        <Button
                            variant="contained"
                            className="edit-tool-action-buttons__discard-button"
                            onClick={() => setEditTool('')}
                        >
                            {t('vod.manage.editor_tab.back')}
                        </Button>
                    )}
                </div>
            )}
        </Box>
    );
};

export default EditToolActionButtons; 